/* eslint-disable  */
//@ts-nocheck

import React from 'react';
import { browserHistory } from 'react-router';
import _ from 'underscore';

import auth from './auth';
import ajax from './ajax';
import * as enums from '@playbook-technologies/common-enums';
import Header from './Header';
import InfluencerSelect from './InfluencerSelect';
import StatusBar from './StatusBar';
import { navigate, PATHS } from '@client/routes';
import { Typography } from '@mui/material';
import { PrimaryButton, SecondaryButton } from '@client/new/components/button';

class PortalUserEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      portalUser: {
        firstName: '',
        lastName: '',
        email: '',
      },
      postData: {
        role: 2,
      },
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.getPortalUserData = this.getPortalUserData.bind(this);
    this.save = this.save.bind(this);
    this.goBack = this.goBack.bind(this);
    this.validate = this.validate.bind(this);
    this.submit = this.submit.bind(this);
    this.merge = this.merge.bind(this);
    this.roleChanged = this.roleChanged.bind(this);
    this.setInput = this.setInput.bind(this);
  }

  setInput(e) {
    const current = this.state;
    current.portalUser[e.target.name] = e.target.value;
    if (
      auth.isModerator() &&
      (this.state.portalUser.firstName || this.state.portalUser.lastName)
    ) {
      current.portalUser.username =
        `${this.state.portalUser.firstName}${this.state.portalUser.lastName}`
          .replace(/\s/g, '')
          .toLowerCase();
    }
    this.setState({ portalUser: current.portalUser });
  }

  componentDidMount() {
    this.getPortalUserData();
  }
  getPortalUserData() {
    //console.log('[PortalUserEdit] Fetching PortalUser data...');
    if (this.props.params.id === 0 || this.props.params.id === '0') {
      let dummy = {
        id: null,
        isActive: true,
        role: enums.PortalUser.Role.Moderator.value,
      };
      this.setState({
        portalUser: dummy,
        postData: dummy,
      });
      return;
    }
    ajax
      .getPortalUsers(this.props.params.id)
      .then((pu) => {
        this.setState({
          portalUser: pu,
          postData: pu,
        });
      })
      .catch((e) => {
        if (e === 'auth') {
          auth.logout();
          return;
        }
        this.setState({
          portalUser: { id: null },
          postData: { id: null },
        });
        StatusBar.sendErrorMessage(
          'You may be experiencing connectivity issues.',
        );
      });
  }
  save(postData) {
    //console.log('[PortalUserEdit] Saving PortalUser...');
    ajax
      .upsertPortalUser(postData)
      .then((pu) => {
        //console.log('[PortalUserEdit] Saved PortalUser.', pu.id);
        navigate(PATHS.PORTAL_USERS);
      })
      .catch((e) => {
        console.log('[PortalUserEdit] Error saving PortalUser.', e);
        if (e === 'auth') {
          auth.logout();
        }
        StatusBar.sendErrorMessage(
          e?.response?.data ??
            e?.message ??
            'An error occured. Please check your data and try again.',
        );
      });
  }
  goBack(e) {
    e.preventDefault();
    browserHistory.goBack();
  }
  validate(data) {
    let validationResult = {
      passed: false,
      messages: [],
    };
    if (data.role === enums.PortalUser.Role.Influencer.value) {
      if (!data.influencerId || parseInt(data.influencerId) < 1) {
        validationResult.messages.push(
          'Users with Partner roles require a selected Partner.',
        );
      }
    }
    if (!data.email || data.email.length < 1) {
      validationResult.messages.push('E-mail address is required.');
    }
    if (validationResult.messages.length === 0) {
      validationResult.passed = true;
    }
    return validationResult;
  }
  submit(e) {
    e.preventDefault();
    var newPostData = _.extend(this.state.postData, this.state.portalUser);

    let validationResults = this.validate(newPostData);
    if (validationResults.passed) {
      this.setState({ postData: newPostData });
      newPostData.role = parseInt(newPostData.role);
      newPostData.influencerId = parseInt(newPostData.influencerId);
      this.save(newPostData);
    } else {
      StatusBar.sendErrorMessage(validationResults.messages.join(' '));
      this.setState({
        postData: newPostData,
      });
    }
  }
  merge(newPostData) {
    this.setState({
      postData: _.extend(this.state.postData, newPostData),
    });
  }
  roleChanged(data) {
    let wat = {
      role: data.role,
      influencerId: data.influencerId,
    };
    this.merge(wat);
  }

  render() {
    let title = 'New User';
    if (this.state.portalUser && this.state.portalUser.firstName) {
      title = `${this.state.portalUser.firstName} ${this.state.portalUser.lastName}`;
    }

    if (!this.state.portalUser) {
      return <span>{this.state.message}</span>;
    }

    return (
      <div className="portalUserEdit">
        <Header>
          <Typography variant="h1">{title}</Typography>
          <div className="box">
            <div className="button-box flex gap-5">
              <PrimaryButton onClick={this.submit}>Save</PrimaryButton>
              <SecondaryButton onClick={this.goBack}>Cancel</SecondaryButton>
            </div>
          </div>
        </Header>
        <main id="main">
          <div>
            <br />
            <div className="general-settings">
              <div className="data-form-holder">
                <div className="data-row row-6">
                  <div
                    className="input-holder"
                    style={{ width: auth.isModerator() ? '100%' : '50%' }}
                  >
                    <label>First Name</label>
                    <input
                      type="text"
                      onChange={this.setInput}
                      name="firstName"
                      value={this.state.portalUser.firstName}
                      placeholder="First name"
                    />
                  </div>
                  <div
                    className="input-holder"
                    style={{ width: auth.isModerator() ? '100%' : '50%' }}
                  >
                    <label>Last Name</label>
                    <input
                      type="text"
                      onChange={this.setInput}
                      name="lastName"
                      value={this.state.portalUser.lastName}
                      placeholder="Last name"
                    />
                  </div>
                </div>
                <RoleEdit
                  role={this.state.postData.role}
                  influencerId={this.state.postData.influencerId}
                  onChange={this.roleChanged}
                />
                <div className="data-block">
                  <div className="input-holder">
                    <label>E-mail:*</label>
                    <input
                      type="text"
                      onChange={this.setInput}
                      name="email"
                      value={this.state.portalUser.email}
                      placeholder="Email"
                    />
                  </div>
                </div>
              </div>
              <p style={{ color: '#f00' }}>{this.state.message}</p>
            </div>
          </div>
        </main>
        <StatusBar.Component />
      </div>
    );
  }
}

export default PortalUserEdit;

// <RoleEdit role={role} influencerId={influencerId} onChange={onRoleChanged} />
class RoleEdit extends React.Component {
  constructor(props) {
    super(props);
    this.roleChanged = this.roleChanged.bind(this);
    this.influencerChanged = this.influencerChanged.bind(this);
  }
  roleChanged(ev) {
    let role = parseInt(ev.target.value);
    let influencerId = this.props.influencerId;
    if (role !== enums.PortalUser.Role.Influencer.value) {
      influencerId = null;
    }
    this.props.onChange({ role, influencerId });
  }
  influencerChanged(option) {
    this.props.onChange({
      role: this.props.role,
      influencerId: option?.value ?? null,
    });
  }
  render() {
    let influencerDropdown = <div className="input-holder"></div>;
    if (this.props.role == enums.PortalUser.Role.Influencer.value) {
      influencerDropdown = (
        <div className="input-holder">
          <label>Related Partner</label>
          <div className="absolute w-96">
            <InfluencerSelect
              influencerId={this.props.influencerId}
              onChange={this.influencerChanged}
            />
          </div>
        </div>
      );
    }
    return (
      <div className="data-row row-6">
        <div className="input-holder">
          <label>Role</label>
          <select value={this.props.role} onChange={this.roleChanged}>
            {auth.isAdministrator() ? (
              <option key="1" value={enums.PortalUser.Role.Administrator.value}>
                Super Admin
              </option>
            ) : (
              ''
            )}
            <option key="2" value={enums.PortalUser.Role.Moderator.value}>
              Admin
            </option>
            <option key="3" value={enums.PortalUser.Role.Influencer.value}>
              Creator
            </option>
            <option key="4" value={enums.PortalUser.Role.ContentEditor.value}>
              Content Editor
            </option>
          </select>
        </div>
        {influencerDropdown}
      </div>
    );
  }
}
